import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';
import { uaCheck, mq } from './modules/utils';

uaCheck();

function jqSmoothScroll() {
  const nav = $('header').length ? $('header').outerHeight() : 0;
  $('a[href^="#"]').on('click', function () {
    const href = $(this).attr('href');
    const target = $(href === '#' || href === '' ? 'html' : href);
    if (target.length) {
      const position = target.offset().top - nav;
      $('html, body').animate({ scrollTop: position }, 500, 'swing');
    }
    return false;
  });

  const { hash } = window.location;
  if (hash) {
    setTimeout(() => {
      const target = $(hash);
      const position = target.offset().top - nav;
      $('html, body').animate({ scrollTop: position }, 500, 'swing');
    });
  }
}

function headerFnc() {
  $(document).on('click', '.toggle-btn', () => {
    $('nav').toggleClass('active');
    $('.toggle-btn').toggleClass('active');
  });
  $('nav a').on('click', () => {
    $('nav').removeClass('active');
    $('.toggle-btn').removeClass('active');
  });

  $('nav li a').each(function () {
    let href = $(this).attr("href");
    if (window.location.href.match(href)) {
      $(this).parent().addClass("current");
    } else {
      $(this).parent().removeClass("current");
    }
  });
}

function device() {
  let agent = navigator.userAgent;
  if (agent.search(/iPhone/) !== -1) {
    $('.app-link').addClass('iphone');
  } else if (agent.search(/Android/) !== -1) {
    $('.app-link').addClass('android');
  }
}

function followingFnc(followingArea) {
  let scrollStart;
  let placeholder = $("<div>").hide(); // ダミー要素

  function initFollowing() {
    const footer = $("footer");
    if (footer.length === 0) return;

    const $following = $(followingArea);
    scrollStart = $following.offset() ? $following.offset().top : 0;

    // ダミー要素を挿入
    placeholder.css({
      height: $following.outerHeight(true), // marginも含めた高さを確保
      display: "none"
    });
    $following.before(placeholder);

    $(window).off("scroll").on("scroll", () => { // イベントの重複登録を防ぐ
      const scroll = $(window).scrollTop();
      const scrollEnd = footer.offset().top;

      $following.removeClass("is-fixed");

      if (scrollStart < scroll && scroll < scrollEnd) {
        placeholder.show(); // 高さを保持
        $following.addClass("is-fixed");
      } else {
        placeholder.hide(); // 元の状態に戻す
        $following.removeClass("is-fixed");
      }
    });
  }

  if ($("footer").length) {
    initFollowing();
  } else {
    const observer = new MutationObserver(() => {
      if ($("footer").length) {
        observer.disconnect();
        initFollowing();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true, attributes: true });
  }
}

function followingBox() {
  const followingArea = '.following-box';
  // main クラスが top でも debit-page でも以下の処理に統一
  followingFnc(followingArea);
}

function accBox() {
  $('.acc-title').on('click', function () {
    $(this).toggleClass('active');
    $(this).next().slideToggle();
  });
}

function bnrSlide() {
  let options = {};
  if ($('.swiper .swiper-slide').length === 1) {
    options = {
      modules: [Navigation],
      loop: false,
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        834: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    };
  } else {
    options = {
      modules: [Navigation],
      loop: true,
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        834: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    };
  }
  const swiper = new Swiper('.swiper', options);
}


function showTab() {
  $('.tab-title p').on('click', function () {
    $('.tab-box').removeClass('active');
    $('.tab-title p').removeClass('active');
    $(this).addClass('active');

    let index = $('.tab-title p').index(this);
    $('.tab-box').eq(index).addClass('active');
  });
}

function redirect() {
  // 現在のURLを取得
  const currentUrl = window.location.href;

  // 特定のパターンに一致するか確認
  if (currentUrl.endsWith('/gate/#counter')) {
    // アンカーリンクを削除してリダイレクト
    const newUrl = currentUrl.replace('#counter', '');
    window.location.href = newUrl;
  }
}

window.addEventListener('load', () => {
  jqSmoothScroll(); // スムーススクロール
  device(); // デバイス判定
  accBox(); // アコーディオン
  bnrSlide(); // バナー
  showTab(); // タブ切り替え
  redirect(); // リダイレクト

  headerFnc(); // ヘッダーのjs
  followingBox(); // バナーエリア
});


// テスト時のみオン、ヘッダーフッターインクルード表記 /////////////
// function includeHTML(url, targetElement, position, callback) {
//   fetch(url)
//     .then(response => response.text()) // HTMLを取得
//     .then(html => {
//       if (position === "before") {
//         targetElement.insertAdjacentHTML("beforebegin", html);
//       } else if (position === "after") {
//         targetElement.insertAdjacentHTML("afterend", html);
//       }
//       if (callback) {
//         callback();
//       }
//     })
//     .catch(error => console.error(`Error loading ${url}:`, error));
// }

// function getRelativePath(path) {
//   // return `/assets/include/${path}`;
//   return `/fv-ssnb/assets/include/${path}`;
// }

// const mainElement = document.querySelector('main');
// if (mainElement) {
//   includeHTML(getRelativePath("header.html"), mainElement, "before");
//   includeHTML(getRelativePath("footer.html"), mainElement, "after", () => {
//     followingBox();
//   });
// }
// ローカルテスト時、ヘッダーフッターインクルード表記 /////////////
